import OrdersEditor from './ordersEditor';

export default OrdersEditor;
